<div class="input">
    <mat-label>{{ label }}</mat-label>
    <mat-select [(ngModel)]="selected">
        <mat-option *ngFor="let item of users" [value]="item.id" (click)="onSelected( item )">{{ item.nombre_cliente }}</mat-option>
    </mat-select>
</div>